import { exportToExcelWithXLSX } from "@perfectserve/library";
import { formatDuration, formatPhoneNumber, formatInteractionForDisplay } from "./formatters";
import { formatInteractionDateTime } from "./dateUtils";
import { calculateReadTime } from "./interactionCalculations";
export const handleInteractionDetailExcelExport = async (processedInteraction) => {
    const formatted = formatInteractionForDisplay(processedInteraction, formatInteractionDateTime);
    const exportData = [
        {
            ...formatted,
            FromCallbackNumber: formatPhoneNumber(processedInteraction.FromCallbackNumber),
            FormattedStartDate: processedInteraction.formattedStartDate,
            FormattedEndDate: processedInteraction.formattedEndDate,
            FormattedDuration: formatDuration(processedInteraction.InteractionTotalTime),
            FormattedReadTime: formatDuration(calculateReadTime(processedInteraction)),
            FormattedCallbackDuration: formatDuration(processedInteraction.CallbackInSeconds),
            FormattedPhone: processedInteraction.formattedPhone,
            Legacy_Interaction_ID: processedInteraction.Id,
            Legacy_Date: processedInteraction.formattedStartDate,
            Legacy_Type: processedInteraction.InteractionFinalAction || "Unknown",
            Legacy_Duration: formatDuration(processedInteraction.InteractionTotalTime),
            Legacy_Read_Time: formatDuration(calculateReadTime(processedInteraction)),
            Legacy_Callback_Duration: formatDuration(processedInteraction.CallbackInSeconds),
            Legacy_Message_Body: processedInteraction.MessageBody || "—",
        },
    ];
    const savedConfig = localStorage.getItem("interaction-detail-export-fields");
    let fieldConfig;
    if (savedConfig) {
        try {
            fieldConfig = JSON.parse(savedConfig);
        }
        catch (_a) {
            fieldConfig = undefined;
        }
    }
    await exportToExcelWithXLSX({
        filename: `Interaction_${processedInteraction.Id || "Detail"}`,
        data: exportData,
        sheetName: "Interaction Detail",
        fieldConfig,
    });
};
export const handleInteractionDetailPdfExport = () => {
    console.log("PDF export will be implemented with html2canvas + jsPDF");
};
//# sourceMappingURL=interactionDetailExportUtils.js.map